import React from 'react'
import './hero.css'
import { Link } from 'react-scroll'
import { BiChevronDown } from 'react-icons/bi'
import TypeAnimation from 'react-type-animation'


const Hero = (props) => {
  const hero = props.data
  const description = hero.description
  return (
   
    <div className='main'>
      <div className='overlay'></div>
       <video loop autoPlay muted>
        <source
          src={`/assets/img/${hero.video}`}
          type="video/mp4"
        />
      </video>
        <div className='content'> 
            <TypeAnimation
            cursor={true}
            sequence={[
              `${hero.title}`,
              2000,
            ]}
            wrapper="h1"
            repeat={1}
           />
           <div className='build'>
          <h1 data-aos="fade-right">{description[0]}</h1>
          <div className="website" data-aos="fade-up" >

          <TypeAnimation
            cursor={true}
            sequence={[
              `${description[1]}`,
              3000,
              `${description[2]}`,
              3000,
              `${description[3]}`,
              2000,
            ]}
            wrapper="h1"
            repeat={Infinity}
            />
            </div>
           </div>
          <Link to="contact" className='mt-5 button' spy={true} smooth={true} offset={-100} duration={300} data-aos="fade-up">START A PROJECT <BiChevronDown size={40} className="text-center"/> </Link>
        
        </div>
          
    </div>
  )
}

export default Hero